import { render, staticRenderFns } from "./AccountApplyCheck.vue?vue&type=template&id=b25125f8&"
import script from "./AccountApplyCheck.vue?vue&type=script&lang=js&"
export * from "./AccountApplyCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports